// @flow

const getUrlParameter = (name) => {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	const regex = new RegExp(`[\\?&]${ name }=([^&#]*)`);
	const results = regex.exec(window.location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

/**
 * Propise formId do URL.
 *
 * @see https://mm.fg.cz/forrest/pl/k6tcrngf3pd7zyu7ji9fk8aidh
 */
export default (): void => {
	if (
		getUrlParameter('formId') === '' &&
		document.querySelectorAll('.js_rememberFormId').length > 0
	) {
		const targetForm = document.querySelector('.js_rememberFormId');
		if ( targetForm == null ) return;

		const formIdElm = targetForm.querySelector('[name="formId"]') || null;
		if ( !(formIdElm instanceof HTMLInputElement) ) return;

		const formId = formIdElm.value || null;
		if ( formId == null ) return;

		let params = window.location.search;
		params += window.location.search.match(/^\?/i) ? '&' : '?';
		params += `formId=${ formId }${ window.location.hash || '' }`;
		window.history.replaceState({},'', window.location.pathname + params);
	}
};



// WEBPACK FOOTER //
// ./fe/web-majetek/src/js/webActions/rememberFormId.js